import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";

const PopoverContent = ({ content, position, onClose }) => {
  const popoverRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return createPortal(
    <div
      ref={popoverRef}
      style={{
        position: "absolute",
        left: `${position.left}px`,
        top: `${position.top}px`,
        zIndex: 1000,
        backgroundColor: "#333",
        color: "#fff",
        borderRadius: "4px",
        padding: "6px 10px",
        fontSize: "12px",
        whiteSpace: "nowrap",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        transform: "translateX(-50%)",
      }}
    >
      {content}
      <div
        style={{
          position: "absolute",
          bottom: "-5px",
          left: "50%",
          transform: "translateX(-50%)",
          width: 0,
          height: 0,
          borderLeft: "5px solid transparent",
          borderRight: "5px solid transparent",
          borderTop: "5px solid #333",
        }}
      />
    </div>,
    document.body
  );
};

const ParticipantsComponent = (props) => {
  const [showPopover, setShowPopover] = useState(false);
  const [position, setPosition] = useState({ left: 0, top: 0 });
  const [tooltipText, setTooltipText] = useState("");

  const data = props.data.indent || {};
  const vendors_participation = data.vendors_participation || {};

  // Calculate Counts
  let acceptedCount = 0;
  let declinedCount = 0;
  let noResponseCount = 0;

  Object.keys(vendors_participation).forEach((vendor) => {
    const status = vendors_participation[vendor].toLowerCase();
    if (status === "accepted") {
      acceptedCount += 1;
    } else if (status === "declined") {
      declinedCount += 1;
    }
  });

  // Get total vendors from vendors_names
  let totalCount = 0;
  try {
    const vendorsArray = data.vendors_names
      ? JSON.parse(data.vendors_names)
      : [];
    totalCount = Array.isArray(vendorsArray) ? vendorsArray.length : 0;
    noResponseCount = totalCount - acceptedCount - declinedCount;
  } catch (err) {
    totalCount = 0;
    noResponseCount = 0;
  }

  const handleMouseEnter = (e, text) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({
      left: rect.left + rect.width / 2,
      top: rect.top - 35 + window.scrollY,
    });
    setTooltipText(text);
    setShowPopover(true);
  };

  const handleMouseLeave = () => {
    setShowPopover(false);
  };

  const handleClick = () => {
    props.context.componentParent.onClickshowparticipants(props);
  };

  return (
    <>
      <div
        style={{
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
          width: "100%",
        }}
      >
        {/* Accepted Count - Green */}
        <span
          style={{ color: "green", cursor: "pointer" }}
          onMouseEnter={(e) => handleMouseEnter(e, "Accepted")}
          onMouseLeave={handleMouseLeave}
        >
          {acceptedCount}
        </span>
        <span style={{ margin: "0 4px" }}>/</span>

        {/* Declined Count - Red */}
        <span
          style={{ color: "red", cursor: "pointer" }}
          onMouseEnter={(e) => handleMouseEnter(e, "Declined")}
          onMouseLeave={handleMouseLeave}
        >
          {declinedCount}
        </span>
        <span style={{ margin: "0 4px" }}>/</span>

        {/* No Response Count - Black */}
        <span
          style={{ color: "black", cursor: "pointer" }}
          onMouseEnter={(e) => handleMouseEnter(e, "No Response")}
          onMouseLeave={handleMouseLeave}
        >
          {noResponseCount}
        </span>
        <span style={{ margin: "0 4px" }}>/</span>

        {/* Total Vendor Count */}
        <span
          style={{ color: "#5C97B5", cursor: "pointer" }}
          onMouseEnter={(e) => handleMouseEnter(e, "Total")}
          onMouseLeave={handleMouseLeave}
        >
          {totalCount}
        </span>

        <button
          className="custom-btn label label-success"
          title="View Vendors"
        >
          <img
            src={require("../../assets/images/view-user.svg")}
            alt="Bid Details"
            onClick={handleClick}
            style={{
              width: "16px",
              height: "16px",
              marginLeft: "4px",
              cursor: "pointer",
              position: "relative",
            }}
          />
        </button>
      </div>

      {showPopover && (
        <PopoverContent
          content={tooltipText}
          position={position}
          onClose={() => setShowPopover(false)}
        />
      )}
    </>
  );
};

export default ParticipantsComponent;



